import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectBalancePayment } from '../../../../../reducers/v2/paymentProcessing/selectors';
import {
  processChangingCheckPaymentStatus,
  EPaymentStatusCheckType,
} from '../../../../../thunks/payment/processChangingCheckPaymentStatus';
import { checkPaymentStatus } from '../../../../../thunks/payment/checkPaymentStatus';

export const usePaymentStatusContainer = () => {
  const dispatch = useDispatch();

  const payment = useSelector(selectBalancePayment);

  const handleRetryClick = useCallback(() => {
    if (payment && payment.paymentId) {
      dispatch(
        checkPaymentStatus({
          onChangePaymentStatus: processChangingCheckPaymentStatus(EPaymentStatusCheckType.Balance),
          paymentId: payment.paymentId,
          provider: payment.provider,
        }),
      );
    }
  }, [dispatch, payment]);

  return { status: payment?.status, handleRetryClick };
};
